import { Component, Show } from "solid-js";

export interface PartialApprovalWarningProps {
  selectedCount: number;
  totalCount: number;
}

export const PartialApprovalWarning: Component<PartialApprovalWarningProps> = (
  props,
) => {
  const skippedCount = () => props.totalCount - props.selectedCount;
  const isPartial = () =>
    props.selectedCount > 0 && props.selectedCount < props.totalCount;

  return (
    <Show when={isPartial()}>
      <div
        class="flex items-start gap-2 text-xs text-signal-amber bg-signal-amber-tint border border-signal-amber/25 rounded p-2.5"
        role="status"
        aria-live="polite"
      >
        <svg
          class="w-3.5 h-3.5 shrink-0 mt-0.5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v2m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        <span>
          Approving {props.selectedCount} of {props.totalCount} actions.{" "}
          {skippedCount()} will be skipped and cannot be re-run from this
          proposal.
        </span>
      </div>
    </Show>
  );
};

export default PartialApprovalWarning;
